export default __webpack_public_path__ + "static/media/Plywood_Meranti.56345c5e.JPG";